import ApiClient from 'clients/api_client'
import Attachment from 'entities/attachment'
import { isEmpty } from 'lodash'

export default class AttachmentClient {
  static upload(file) {
    const url = Routes.attachmentsPath()
    const formData = new FormData()
    formData.append('attachment[file]', file)

    return ApiClient.post(url, formData)
      .then(({ data }) => new Attachment(data))
      .catch(AttachmentClient.handleErrors)
  }

  static uploadRemoteUrl(remoteFileUrl) {
    const url = Routes.attachmentsPath()
    const formData = new FormData()
    formData.append('attachment[remote_file_url]', remoteFileUrl)

    return ApiClient.post(url, formData)
      .then(({ data }) => new Attachment(data))
      .catch(AttachmentClient.handleErrors)
  }

  static handleErrors(error) {
    // 現状の attachments_controller はステータスコードしか返さないので
    // ここでエラーハンドリングを別途行いエラーオブジェクトを付与する
    const newError = error
    if (isEmpty(newError.error)) {
      const errorObject = {
        errors: [['file', I18n.t('common.message.upload.failure')]]
      }
      newError.error = errorObject
    }
    throw newError
  }
}
